export const ALIDADE_SMOOTH = "alidade_smooth";
export const ALIDADE_SATELLITE = "alidade_satellite";
export const PLANET = "planet";

// Planet tile pyramids are fragmented strips below z=16: transforms
// (blue-excess, NDWI, ...) render with holes (measured 8% coverage at z=10,
// ~45% at z=13, ~84% at z=15). At z>=16 the pyramids fully cover the
// district (100% on all transform types). Suppress planet-family sources
// below this zoom so the stadia base shows instead.
export const PLANET_MIN_ZOOM = 16;
